<app-common-header></app-common-header>
<style>
  .ng-dropdown-panel-items.scroll-host {
  max-height: none !important;
}
</style>
<main role="main" class="maincntq">
  <div class="getbannersect sectppad pb-2">
    <div class="sectpad container-fluid">
      <div class="col-12 text-center webview">
        <img src="assets/images/signimg.jpg" class="signimg signimgg" />
      </div>
      <div class="col-sm-12 p-0 webview" [@flyInOut]="'in'">
        <div class="card-wrapper m-auto">
          <div class="col-md-12 mt-5">
            <h1 class="text-center ssnHeadTxt">
              It looks like a deposit is<br />
              required to sign up for this
            </h1>
            <div class="col-md-11 m-auto">
              <div class="">
                <span class="ssnTxt d-inline-block mt-3"
                  >In order to complete signing up for this plan, you are kindly
                  being asked to post a {{ depositamount }} deposit, or you can
                  see if you are eligible to have your deposit waived.
                </span>
                <span class="ssnTxt d-inline-block mt-3"
                  >If you choose to pay the deposit, it will be returned to you
                  with interest after one year as a customer-in-good-standing
                  with BKV Energy, or if you move-out of your location
                  before your contract expires. Please see your Terms of Service
                  for BKV Energy’s Deposit Policy.
                </span>
                <span class="ssnTxt d-inline-block mt-3 mb-3"
                  ><strong
                    style="
                      font-size: 19px !important;
                      font-family: 'Calibre-SemiBold';
                    "
                    >IMPORTANT:</strong
                  >
                  Choosing to waive your deposit may impact the service start
                  date that you had previously requested due to amount of time
                  it takes to process and validate.
                </span>
              </div>
              <div class="col-md-11 m-auto text-left">
                <label
                  class="custom-control custom-checkbox chkbox mb-2 box-shadow"
                  for="payfordeposit"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input mgntp10"
                    id="payfordeposit"
                    value="Paythe$175deposit"
                    name="payfordeposit"
                    [(ngModel)]="ssndepostList.value4"
                    (click)="onChangeRole($event)"
                  />
                  <label
                    class="custom-control-label font16 ml-2"
                    for="payfordeposit"
                    style="
                    color: black !important;
                    font-weight: normal !important;
                  "
                    >{{ label }}</label
                  >
                </label>
                <label
                  class="custom-control custom-checkbox chkbox mb-2 box-shadow"
                  for="applydepositwaiver"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input mgntp10"
                    id="applydepositwaiver"
                    value="Applyforadepositwaiver"
                    name="applydepositwaiver"
                    [(ngModel)]="ssndepostList.value5"
                    (click)="onChangeRole($event)"
                  />
                  <label
                    class="custom-control-label font16 ml-2"
                    for="applydepositwaiver"
                    style="
                    color: black !important;
                    font-weight: normal !important;
                  "
                    >Apply for a deposit waiver</label
                  >
                </label>
              </div>

              <div
                class="col-md-12 ng-tns-c2-0 ng-star-inserted"
                *ngIf="Paythe$175deposit && !Applyforadepositwaiver"
              >
                <div class="col-md-12 px-0">
                  <div class="row font19-weight-semibold-calibre">
                    {{ setCardTextAutoPayBased() }}
                  </div>
                  <br />
                  <div
                    class="card-wrapper-deposit"
                    data-jp-card-initialized="true"
                  >
                    <div class="jp-card-container" style="transform: scale(1)">
                      <div id="jp-card-details" class="jp-card">
                        <div class="jp-card-front">
                          <div class="jp-card-logo jp-card-elo">
                            <div class="e">e</div>
                            <div class="l">l</div>
                            <div class="o">o</div>
                          </div>
                          <div class="jp-card-logo jp-card-visa" *ngIf="isVisa">
                            Visa
                          </div>
                          <div class="jp-card-logo jp-card-visaelectron">
                            Visa
                            <div class="elec">Electron</div>
                          </div>
                          <div class="jp-card-logo jp-card-mastercard">
                            Mastercard
                          </div>
                          <div class="jp-card-logo jp-card-maestro">
                            Maestro
                          </div>
                          <div class="jp-card-logo jp-card-amex"></div>
                          <div class="jp-card-logo jp-card-discover">
                            discover
                          </div>
                          <div class="jp-card-logo jp-card-unionpay">
                            UnionPay
                          </div>
                          <div class="jp-card-logo jp-card-dinersclub"></div>
                          <div class="jp-card-logo jp-card-hipercard">
                            Hipercard
                          </div>
                          <div class="jp-card-logo jp-card-troy">troy</div>
                          <div class="jp-card-logo jp-card-dankort">
                            <div class="dk">
                              <div class="d"></div>
                              <div class="k"></div>
                            </div>
                          </div>
                          <div class="jp-card-logo jp-card-jcb">
                            <div class="j">J</div>
                            <div class="c">C</div>
                            <div class="b">B</div>
                          </div>
                          <div class="jp-card-lower">
                            <div class="jp-card-shiny"></div>
                            <div class="jp-card-cvc jp-card-display">•••</div>
                            <div class="jp-card-number jp-card-display">
                              {{ validateCardDisplay('auto') }}
                            </div>
                            <div class="jp-card-name jp-card-display">
                              {{ validateFullName('auto') }}
                            </div>
                            <div
                              class="jp-card-expiry jp-card-display"
                              data-before="mm/yy"
                              data-after="validdate"
                            >
                              {{ month }}/{{ year }}
                            </div>
                          </div>
                        </div>
                        <div class="jp-card-back">
                          <div class="jp-card-bar"></div>
                          <div class="jp-card-cvc jp-card-display">
                            {{ validateSecurityCode('auto') }}
                          </div>
                          <div class="jp-card-shiny"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-md-7 px-0" id="cdNum">
                      <input
                        class="form-control"
                        type="text"
                        id="txtCardNumber"
                       

                        [maxlength]="maxLength"
                        placeholder="Credit Card Number"
                        (change)="validateCreditCardNumber('auto')"
                        (keyup)="onChangeTxtCardNumber($event,false)"
                        (keypress)="numberOnly($event)"
                        [(ngModel)]="formattedCardNumber"

                      />
                    </div>
                    <div class="col-md-5">
                      <img
                        style="width: 130px; height: auto !important"
                        class="mt-1"
                        src="/assets/images/cc-cards-images1.png"
                      />
                    </div>

                    <div
                      *ngIf="validCard && formattedCardNumber.length > 10"
                      class="col-sm-12 px-0"
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        That card number did not work. Try again using Visa,
                        MasterCard, Discover or American Express
                      </div>
                    </div>
                    <div
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes('DepositCreditCard Number')
                      "
                      class="col-sm-12 px-0"
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        That card number did not work. Please try re-entering it
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 px-0">
                      <div class="col-sm-12 px-0 mt-2">
                        <label class="font19-weight-semibold-calibre"
                          >Expiration Date*</label
                        >
                      </div>
                      <div class="col-md-12 d-flex px-0">
                        <div class="mm-yy mr-3">
                          <ng-select
                          [items]="monthList"
                          bindLabel="Text"
                          bindValue="Value"
                          placeholder="MM"
             
                          id="cmonth"
                          name="month"
                          [searchable]="false" [clearable]="false"
                          [(ngModel)]="month"
                          (change)="validateMonth()"
                          style="width: 110px"
                          >
                        </ng-select>
                        </div>
                        <div class="mm-yy">
                          <ng-select
                          [items]="yearsList"
                          bindLabel="Text"
                          bindValue="Value"
                          placeholder="YYYY"
                          [searchable]="false" [clearable]="false"
                         
                          name="year"
                          id="cyear"
                          [(ngModel)]="year"
                          (change)="validateYear()"
                          style="width: 110px; z-index: 9999;"
                           >
                          </ng-select>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-4 px-0">
                      <div class="col-sm-12 mt-2 pr-0">
                        <label class="font19-weight-semibold-calibre"
                          >Security Code*</label
                        >
                      </div>
                      <div class="col-sm-11" style="padding-left: 75px">
                        <input
                          class="form-control"
                          numbersOnly
                          [(ngModel)]="secuiritycode"
                          type="text"
                          (change)="validatecvv($event)"
                          id="ccode"
                          (keyup)="
                          flipCardForSecurityCode($event.target.value, 'auto')
                          "
                          name="secuiritycode"
                          placeholder="CVV"
                          maxlength="4"
                          size="4"
                          required="true"
                          style="width: 64px; height: 38px"
                        />
                      </div>

                      <!-- <div class="ml-3" *ngIf="ccodeisNull === true" style="font-size: 16px !important;color: #ED1976 !important;">
                    <div class="alertMsg">Security code is required and cannot be left blank.</div>
                  </div> -->
                    </div>

                    <div class="row">
                      <div
                        class="ml-3"
                        *ngIf="blankmontherr"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please provide the Expiration Month (MM)
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="blankyearerr"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please provide the Expiration Year (YYYY)
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="showmontherr || yearErrorFlag"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          {{ errorMessage }}
                        </div>
                      </div>
                      <div
                        *ngIf="
                          postResponseMessage &&
                          (postResponseMessage.includes(
                            'DepositCreditCardYear'
                          ) ||
                            postResponseMessage.includes(
                              'DepositCreditCardMonth'
                            ))
                        "
                        class="ml-3"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          {{ errorMessage }}
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="cvvValid"
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Security code is invalid. Please verify and try again.
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'DepositCreditCard CVV/CID'
                          )
                        "
                        style="
                          font-size: 14px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Security code is invalid. Please verify and try again.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mt-2 px-0">
                      <label class="font19-weight-semibold-calibre"
                        >Name as it appears on card*</label
                      >
                    </div>
                    <div class="col-sm-10 pl-0">
                      <input
                        type="text"
                        IsAlphaNumeric
                        class="form-control"
                        (change)="validateccName($event)"
                        [(ngModel)]="cardName"
                        (keyup)="flipCardFront('auto')"
                        id="cardname"
                        name="cardname"
                        placeholder="First and last name"
                        required="true"
                        style="width: 325px !important; height: 38px !important"
                      />
                    </div>
                    <div
                      class="col-sm-12 px-0"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes(
                          'Required Deposit card billing Info'
                        )
                      "
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        Required information is missing. Please verify your
                        details and try again.
                      </div>
                    </div>
                    <div
                      class="col-sm-12 px-0"
                      *ngIf="checkCardName"
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">
                        Please provide your First and Last Name
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 mt-2 px-0">
                      <label class="font19-weight-semibold-calibre"
                        >Billing Address*</label
                      >
                    </div>
                    <br />
                    <div class="col-sm-12 d-flex px-0">
                      <div class="col-sm-10 pl-0 mb-2">
                        <input
                          type="text"
                          id="street_address"
                          [(ngModel)]="street_address"
                          class="form-control"
                          (ngModelChange)="validate()"
                          placeholder="Street Address"
                        />
                      </div>
                      <div class="col-sm-2 mb-2 px-0">
                        <div>
                          <input
                            type="text"
                            id="apt"
                            [(ngModel)]="apt"
                            class="form-control"
                            (ngModelChange)="validate()"
                            placeholder="Apt"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-12 px-0 alertMsg"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes(
                          'BillingAddress has reached its character limit'
                        )
                      "
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                        margin-top: -3px !important;
                      "
                    >
                      Please enter a valid Billing Address
                    </div>
                    <div
                      class="col-md-12 px-0 alertMsg"
                      *ngIf="street_addressisNull === true"
                      style="
                        font-size: 14px !important;
                        color: #ed1976 !important;
                        margin-top: -3px !important;
                      "
                    >
                      Billing Address is required and cannot be left blank
                    </div>
                    <div class="row mb-2 pr-0 mt-2">
                      <div class="col-sm-5 pr-0">
                        <input
                          type="text"
                          id="city"
                          [(ngModel)]="city"
                          (ngModelChange)="validate()"
                          class="form-control"
                          placeholder="City"
                        />
                      </div>
                      <div class="col-sm-4 select-font16">
                        <ng-select
                          [items]="statesArr"
                          placeholder="Select"
                          [searchable]="false"
                          [clearable]="false"
                          name="selectedstate"
                          [(ngModel)]="state"
                          (change)="getState(state)"
                          #selectedstate="ngModel"
                        >
                        </ng-select>
                      </div>
                      <div class="col-sm-3 pl-0">
                        <input
                          type="tel"
                          numbersOnly
                          [(ngModel)]="zipcode"
                          (ngModelChange)="validate()"
                          class="form-control"
                          maxlength="5"
                          placeholder="Zip"
                          id="zipcode"
                        />
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="cityisNull === true"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          City is required and cannot be left blank
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes('BillingCity')
                        "
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">Please enter a valid City</div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="
                          zipInvalidLength === true ||
                          (postResponseMessage &&
                            postResponseMessage.includes('Zipcode'))
                        "
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Please enter a 5-digit Zip Code
                        </div>
                      </div>
                      <div
                        class="ml-3"
                        *ngIf="zipcodeisNull === true"
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          Zipcode is required and cannot be left blank
                        </div>
                      </div>

                      <div
                        class="ml-3"
                        *ngIf="
                          postResponseMessage &&
                          postResponseMessage.includes(
                            'Unable to process your payment'
                          )
                        "
                        style="
                          font-size: 16px !important;
                          color: #ed1976 !important;
                        "
                      >
                        <div class="alertMsg">
                          We are unable to process your payment. Please verify
                          your deposit details and try again.
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="row">
                      <div
                        class="custom-control custom-checkbox chkbox mb-0"
                        style="
                          padding-left: 15px;
                          margin-bottom: 0px !important;
                          margin-top: 0 !important;
                          border: none;
                        "
                      >
                        <input
                          type="checkbox"
                          id="accept"
                          class="custom-control-input"
                          [(ngModel)]="accpetterms"
                        />
                        <label
                          style="
                              cursor: pointer !important;
                              line-height: 100%;
                              font-size: 19px !important;
                              font-weight: normal;
                              color: black !important;
                          "
                              
                          class="custom-control-label mt-1"
                          for="accept"
                          >I authorize BKV Energy to charge me the above
                          mentioned amount of {{ depositamount }} with the
                          payment account information provided. I understand
                          that this is required to complete the setup of
                          establishing service with BKV Energy.</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="row ng-tns-c2-0 ng-star-inserted"
                *ngIf="Applyforadepositwaiver && !Paythe$175deposit"
              >
                <div class="col-sm-12 mt-2">
                  <div id="order">
                    <label
                      for="font-weight-semibold-calibre"
                      style="
                        font-size: 19px !important;
                        font-family: 'Calibre-SemiBold' !important;
                      "
                      >Choose from the following deposit waiver reasons</label
                    >
                    <div id="select19px">
                      <!-- <select [(ngModel)]="waiverreason" (change)="checkreasonExists(waiverreason)" class="dropdown-toggle form-control" name="waiverreason" required
                    >
                    <option value="Select one"  >Select one</option>
                    <option value="I can provide 12 months of good payment history">I can provide 12 months of good payment history</option>
                    <option value="Senior Citizens in Good Standing">Senior Citizens in Good Standing</option>
                    <option value="Victim of Family Violence">Victim of Family Violence</option>
                    <option value="Medically Indigent">Medically Indigent</option>
                    <option value="Active Hospital Employee">Active Hospital Employee</option>
                    <option value="Active Military Duty">Active Military Duty</option>
                  </select> -->

                      <ng-select
                        name="waiverreason"
                        id="waiverreasonDropdown"
                        [items]="waiverreasons"
                        placeholder="Select one"
                        [searchable]="false"
                        [clearable]="false"
                        (change)="checkreasonExists($event)"
                        [(ngModel)]="waiverreason"
                      ></ng-select>
                    </div>
                  </div>

                  <div  *ngIf="IsReasonDes"  class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3" [innerHTML]="ReasonDes"></span>
                  </div>

                  <!-- 
                  <div *ngIf="victimreason" class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >If you are a victim of family violence, as defined in the
                      Texas Family Code §71.004, by a family violence center as
                      defined in Texas Human Resource Code §51.002, by treating
                      medical personnel, by law enforcement personnel, by the
                      Office of the Texas District Attorney or County Attorney,
                      by the Office of the Attorney General, or by a grantee of
                      the Texas Equal Access to Justice Foundation; you may be
                      eligible to have your deposit waived.
                    </span>
                    <span class="ssnTxt d-inline-block mb-3"
                      >You will need to provide your certified Letter for Family
                      Violence from the Texas Council on Family Violence which
                      can be downloaded here:<br />
                      <a
                        href="https://tcfv.org/survivor-resources"
                        target="_blank"
                        style="color: #0055ff"
                      >
                        https://tcfv.org/survivor-resources
                      </a>
                      found under “Utility Waivers.”
                    </span>
                  </div>

                  <div *ngIf="seniorcitizen" class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >Please provide proof that the Account Holder is 65 years
                      of age or older, and a copy of the most recent electric
                      invoice, to be eligible to have your deposit waived.
                    </span>
                  </div>

                  <div *ngIf="paymenthistory" class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >Please provide a Letter of Credit from your current
                      Retail Electric Provider, or show 12 consecutive months of
                      billing and payment history with no more than 2 late
                      payments, to be eligible to have your deposit waived.
                    </span>
                  </div>

                  <div *ngIf="activehospitalemp" class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >Active hospital employees are eligible to have their
                      deposit waived. Please submit a copy of a valid,
                      non-expired, hospital-issued employee picture ID.
                    </span>
                  </div>

                  <div *ngIf="activemilateryduty" class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >Active military personnel are eligible to have their
                      deposit waived. Please submit a copy of a valid,
                      non-expired, military-issued ID.
                    </span>
                  </div>

                  <div *ngIf="activemedicalindigent" class="col-md-12 px-0">
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >Please provide documentation showing that (1) the
                      household income is at or below 150% of the poverty
                      guidelines. This can be obtained from a governmental
                      entity or a government funded energy assistance program.
                      Participating agencies can be found here: <br />

                      <a
                        href="https://www.tdhca.state.tx.us/community-affairs/ceap"
                        target="_blank"
                        >https://www.tdhca.state.tx.us/community-affairs/ceap</a
                      ><br /><br />

                      And, (2) the customer or applicant, or the spouse of the
                      customer or applicant must have been certified by that
                      person’s physician as being unable to perform three or
                      more activities of daily living as defined in 22 TAC
                      §224.4, or the customer’s or applicant’s monthly
                      out-of-pocket medical expenses must exceed 20% of the
                      household’s gross income. <br /><br />

                      For purposes of this subsection, the term “physician”
                      shall mean any medical doctor, doctor of osteopathy, nurse
                      practitioner, registered nurse, state-licensed social
                      workers, state-licensed physical and occupational
                      therapists, and an employee of an agency certified to
                      provide home health services pursuant to 42 U.S.C. §1395
                      et seq.
                    </span>
                  </div>

                  <div
                    class="col-sm-12 px-0"
                    *ngIf="
                      victimreason ||
                      seniorcitizen ||
                      paymenthistory ||
                      activehospitalemp ||
                      activemilateryduty ||
                      activemedicalindigent
                    "
                  >
                    <label
                      for="font-weight-semibold-calibre"
                      style="
                        font-size: 19px !important;
                        font-family: 'Calibre-SemiBold' !important;
                      "
                      >How would you like to provide your documentation</label
                    >

                    <ng-select
                      name="wayofcontact"
                      [items]="providewaystocontact"
                      placeholder="Select one"
                      [searchable]="false"
                      [clearable]="false"
                      (change)="providewaystocontactExists($event)"
                      [(ngModel)]="wayofcontact"
                    ></ng-select>
                  </div> -->

                  
                  <div
                    class="col-sm-12 px-0"
                    *ngIf="
                    IsReasonDes
                    "
                  >
                    <label
                      for="font-weight-semibold-calibre"
                      style="
                        font-size: 19px !important;
                        font-family: 'Calibre-SemiBold' !important;
                      "
                      >How would you like to provide your documentation</label
                    >

                    <ng-select
                      name="wayofcontact"
                      [items]="providewaystocontact"
                      placeholder="Select one"
                      [searchable]="false"
                      [clearable]="false"
                      (change)="providewaystocontactExists($event)"
                      [(ngModel)]="wayofcontact"
                    ></ng-select>
                  </div>

                  <div
                    *ngIf="
                      emailorfax &&
                      waiverreason != 'Select one' &&
                      wayofcontact != 'Select one'
                    "
                    class="mt-3 col-md-12 px-0"
                  >
                    <span class="ssnTxt d-inline-block mb-3"
                      >To apply, please send your documents to BKV Energy
                      via email or fax in order to proceed with your enrollment
                      request.
                    </span>

                    <div
                      class="col-lg-12 px-0"
                      style="line-height: 1.3 !important"
                    >
                      <img
                        src="{{ selectedProduct.energy_provider_image }}"
                        class="text-center"
                        width="140"
                      />

                      <div class="row font19">
                        <div class="col-12 d-flex px-0">
                          <div class="col-4">Hours:</div>
                          <div class="col-8">
                            Monday to Friday 8:00 AM to 9:00 PM <br />
                            Saturday 8:00 AM to 5:00 PM
                          </div>
                        </div>
                        <div class="col-12 d-flex px-0">
                          <div class="col-4">Customer Care:</div>
                          <div class="col-8">
                            <a
                              [href]="'tel:' + '1-855 BKV 4PWR(258-4797)'"
                              style="color: blue; cursor: pointer !important"
                            >
                            1 855 BKV 4PWR(258-4797)</a
                            >
                          </div>
                        </div>
                        <div class="col-12 d-flex px-0">
                          <div class="col-4">Email:</div>
                          <div class="col-8">
                            <span
                              style="
                                color: blue;
                                text-decoration: underline;
                                cursor: pointer;
                              "
                              (click)="
                                mailMe('support@bkvenergy.com')
                              "
                              >support@bkvenergy.com</span
                            >
                          </div>
                        </div>
                        <div class="col-12 d-flex px-0">
                          <div class="col-4">Fax:</div>
                          <div class="col-8">713-893-6012</div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="d-flex border text-center mb-2 brdrads">
                            <div class="row justify-content-center align-self-center col-xs-12 col-md-4"> <img src="{{selectedProduct.energy_provider_image}}" class="text-center" style="width:110px; height:auto; padding: 0 10px;"></div>
                            <div class="col-xs-12 col-md-8">
                              <address>
                              <p class="text-left mb-1 lneHgt">
                                Customer Service Hours:<br/>
                                Monday - Friday: 8 a.m. to 6 p.m. CST<br/>
                             Phone: 1-855-780-5209<br/>
                             Email: customercare@myBKVenergy.com<br/>
                             Fax:713-583-5946
                              </p>
                            </address>
                            </div>
                          </div> -->

                    <span class="ssnTxt d-inline-block mt-2 mb-2"
                      >You must email or fax your documentation to BKV
                      Energy within two (2) business days of the submitted
                      enrollment request. If you do not send your documentation
                      within two (2) business days, then your service request
                      will be cancelled and will be required to restart the
                      enrollment request process all over again.</span
                    >
                  </div>

                  <div
                    *ngIf="
                      isuploadfile &&
                      waiverreason != 'Select one' &&
                      wayofcontact != 'Select one'
                    "
                    class="col-md-12 px-0"
                  >
                    <span class="ssnTxt d-inline-block mt-3 mb-3"
                      >To apply, please upload your document(s).
                    </span>

                    <div class="row col-sm-12 px-0 mb-2 ml-0 mr-0 borfderbtm">
                      <div
                        class="col-sm-12 px-0 text-center font16 semi-bold oneSpaces mb-2"
                      >
                        <label
                          class="upload-button text-center handsymbol boxbackgrdclr"
                          [ngClass]="{
                            'another-file-over': hasAnotherDropZoneOver
                          }"
                          style="cursor: pointer !important"
                        >
                          <div
                            id="drop-areamob"
                            (click)="fileOverAnothermobile($event)"
                          >
                            <span style="line-height: 100%">
                              <p
                                class="font16 semi-bold oneSpaces mt-3 fileUploadbottom fileUploadbottomHgt"
                              >
                                DRAG AND DROP OR CLICK HERE TO UPLOAD
                              </p>
                              <p
                                class="font13 oneSpaces regularfontFamily fileUploadbottom fileUploadbottomHgt"
                              >
                                Max File Size: 10MB<br />
                                Acceptable File Types: JPG, PNG, PDF
                              </p>
                            </span>
                          </div>
                          <input
                            type="file"
                            (change)="onTempImageSelected($event)"
                            accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp"
                            multiple
                            name = 'photo'
                          />
                        </label>
                        <ul class="upldfile">
                          <li *ngFor="let fileobj of listofFiles">
                            <div
                              class="handsymbol uploded"
                              *ngIf="listofFiles.length > 0"
                            >
                              <i class="fa fa-file mr-2"></i>
                              <span
                                >{{ fileobj.File.name }}
                                <small
                                  class="text-muted clearfix float-left w-100"
                                  >{{ fileobj.File.unitSize }}</small
                                >
                              </span>
                              <font
                                class="upldclose"
                                (click)="removeFile(fileobj)"
                                >x</font
                              >
                            </div>
                          </li>
                          <li
                            class="text-left alertMsg"
                            style="font-size: 12px !important"
                            *ngIf="listofFiles.length > 3"
                          >
                            Maximum of three (3) deposit documents allowed for
                            upload
                          </li>
                          <li
                            class="text-left alertMsg"
                            style="font-size: 12px !important"
                            *ngIf="invalidFileMsg"
                          >
                            Only JPEG, PNG and PDF files are acceptable file
                            types
                          </li>
                          <li
                            class="text-left alertMsg"
                            style="font-size: 12px !important"
                            *ngIf="invalidFileSizeMsg"
                          >
                            This file is too big to upload. Max file size: 10 MB
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div
                      class="ml-3"
                      *ngIf="
                        postResponseMessage &&
                        postResponseMessage.includes(
                          'Required deposit Document'
                        )
                      "
                      style="
                        font-size: 16px !important;
                        color: #ed1976 !important;
                      "
                    >
                      <div class="alertMsg">Please upload another file</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-12 text-center ng-tns-c2-0 ng-star-inserted my-3"
              *ngIf="Applyforadepositwaiver && !Paythe$175deposit"
            >
              <button
                class="btn sectbtn mt-2 m-auto"
                style="
                  width: auto !important;
                  padding-left: 25px;
                  font-size: 18px !important;
                  padding-right: 25px;
                "
                [ngClass]="{ sectbtn: user_bot, disabledButton: !user_bot }"
                (click)="SendApiDetsils()"
                [disabled]="isDisable"
              >
                Submit Waiver
              </button>
            </div>

            <div
              class="col-sm-12 text-center ng-tns-c2-0 ng-star-inserted my-3"
              *ngIf="!Applyforadepositwaiver && Paythe$175deposit"
            >
              <button
                class="btn sectbtn mt-2 m-auto"
                style="
                  width: auto !important;
                  padding-left: 25px;
                  font-size: 18px !important;
                  padding-right: 25px;
                "
                [ngClass]="{ sectbtn: user_bot, disabledButton: !user_bot }"
                (click)="SendApiDetsils()"
                [disabled]="isDisable"
              >
                <i class="fa fa-lock mr-1" aria-hidden="true"></i>Pay Deposit
                Now
              </button>
            </div>

            <!-- <div class="mt-3" *ngIf="postResponseMessage">
            <div class="m-auto col-sm-4 col-md-10 col-xl-6 blockbg boxclr text-center">
              <p class="text-center tipmes">{{postResponseMessage}}</p>
            </div>
          </div> -->
            <div
              class="m-auto col-md-10 blockbg boxclr text-center mt-3 py-4 px-3"
              *ngIf="postResponseMessage"
              style="vertical-align: middle; line-height: 1"
            >
              <p
                class="text-center tipmes mb-0"
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes('DepositCreditCard Number')
                "
              >
                We are unable to process your deposit payment. Please verify
                your details and try again.
              </p>
              <p
                class="text-center tipmes mb-0"
                *ngIf="
                  postResponseMessage &&
                  !postResponseMessage.includes(
                    'Unable to process your payment, please verify your details.'
                  ) &&
                  !postResponseMessage.includes('DepositCreditCard Number') &&
                  !postResponseMessage.includes(
                    'Input contains a non-ASCII character'
                  )
                "
              >
                {{ postResponseMessage }}
              </p>
              <p
                class="text-center tipmes mb-0"
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes(
                    'Input contains a non-ASCII character'
                  )
                "
              >
              {{ postResponseMessage }}
              </p>
              <p
                class="text-center tipmes mb-0"
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes(
                    'Unable to process your payment, please verify your details.'
                  )
                "
              >
                We are unable to process your payment. Please verify your
                deposit details and try again.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row-fluid mobileview mt-4 pt-4">
        <div class="d-flex h-100 row pr-0">
          <div
            class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
          >
            <img
              style="width: 100% !important"
              src="assets/images/signimg.jpg"
            />
          </div>
          <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box mr-3" [@flyOut]="'in'">
              <h1 class="questionMob text-left">
                It looks like a deposit is required to sign up for this plan.
              </h1>
            </div>
          </div>
        </div>
        <h1
          class="text-center"
          style="font-size: 19px; font-family: Calibre-semiBold"
        >
          Deposit Required
        </h1>
        <div class="d-flex h-100 row pr-0 mt-2">
          <div class="col-sm-3 col-3 pl-0"></div>
          <div class="col-sm-9 col-9 pl-0 pr-4">
            <span class="ssnTxt d-inline-block mt-2"
              >To complete signing up for this plan, you are kindly being asked
              to post a {{ depositamount }} deposit, or you can see if you are
              eligible to have your deposit waived.
            </span>

            <span class="ssnTxt d-inline-block mt-2"
              >If you choose to pay the deposit, it will be returned to you with
              interest after one year as a customer-in-good-standing with
              BKV Energy, or if you move-out of your location before your
              contract expires. Please see your Terms of Service for BKV
              Energy’s Deposit Policy.
            </span>

            <span class="ssnTxt d-inline-block mt-2"
              ><strong
                style="
                  font-size: 19px !important;
                  font-family: 'Calibre-SemiBold';
                "
                >IMPORTANT:</strong
              >
              Choosing to waive your deposit may impact the service start date
              that you had previously requested due to amount of time it takes
              to process and validate.
            </span>
          </div>
          <div class="col-sm-3 col-3 pl-0"></div>
          <div
            class="col-sm-9 col-9 pl-0 pr-4"
           
          >
            <label
              class="custom-control custom-checkbox chkbox mb-2 box-shadow"
              for="payfordepositt"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="payfordepositt"
                value="Paythe$175deposit"
                name="payfordeposit"
                [(ngModel)]="ssndepostList.value4"
                (click)="onChangeRole($event)"
              />
              <label
                class="custom-control-label font20 ml-2"
                for="payfordepositt"
                style="  color: black !important;
                font-weight: normal !important;"
                >{{ label }}</label
              >
            </label>
            <label
              class="custom-control custom-checkbox chkbox mb-2 box-shadow"
              for="applydepositwaiverr"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="applydepositwaiverr"
                value="Applyforadepositwaiver"
                name="applydepositwaiver"
                [(ngModel)]="ssndepostList.value5"
                (click)="onChangeRole($event)"
              />
              <label
                class="custom-control-label font20 ml-2"
                for="applydepositwaiverr"
                style="  color: black !important;
                font-weight: normal !important;"
                >Apply for a deposit waiver</label
              >
            </label>
          </div>
          <div class="col-sm-3 col-3 pl-0"></div>
          <div
            class="col-sm-9 col-9 pl-0 pr-4"
            *ngIf="Paythe$175deposit"
           
          >
            <div class="col-sm-12 px-0">
              <div class="row font19-weight-semibold-calibre">
                {{ setCardTextAutoPayBased() }}
              </div>
              <br />
              <div
              class="card-wrapper-auto-pay"
              data-jp-card-initialized="true"
            >
              <div class="jp-card-container">
                <div class="jp-card" id="auto-card-details" style="min-width: 0 !important;">
                  <div class="jp-card-front">
                    <div class="jp-card-logo jp-card-elo">
                      <div class="e">e</div>
                      <div class="l">l</div>
                      <div class="o">o</div>
                    </div>
                    <div id="visa" class="jp-card-logo jp-card-visa">
                      Visa
                    </div>
                    <div class="jp-card-logo jp-card-visaelectron">
                      Visa
                      <div class="elec">Electron</div>
                    </div>
                    <div class="jp-card-logo jp-card-mastercard">
                      Mastercard
                    </div>
                    <div class="jp-card-logo jp-card-maestro">
                      Maestro
                    </div>
                    <div class="jp-card-logo jp-card-amex"></div>
                    <div class="jp-card-logo jp-card-discover">
                      discover
                    </div>
                    <div class="jp-card-logo jp-card-unionpay">
                      UnionPay
                    </div>
                    <div class="jp-card-logo jp-card-dinersclub"></div>
                    <div class="jp-card-logo jp-card-hipercard">
                      Hipercard
                    </div>
                    <div class="jp-card-logo jp-card-troy">troy</div>
                    <div class="jp-card-logo jp-card-dankort">
                      <div class="dk">
                        <div class="d"></div>
                        <div class="k"></div>
                      </div>
                    </div>
                    <div class="jp-card-logo jp-card-jcb">
                      <div class="j">J</div>
                      <div class="c">C</div>
                      <div class="b">B</div>
                    </div>
                    <div class="jp-card-lower">
                      <div class="jp-card-shiny" style="margin-bottom: 28px;"></div>
                      <div class="jp-card-cvc jp-card-display">•••</div>
                      <div class="jp-card-number jp-card-display" style="font-size: 20px;">
                        {{ validateCardDisplay('auto') }}
                      </div>
                      <div class="jp-card-name jp-card-display">
                        {{ validateFullName('auto') }}
                      </div>
                      <div
                        class="jp-card-expiry jp-card-display"
                        data-before="mm/yy"
                        data-after="validdate"
                      >
                        {{ month }}/{{ year }}
                      </div>
                    </div>
                  </div>
                  <div class="jp-card-back">
                    <div class="jp-card-bar"></div>
                    <div class="jp-card-cvc jp-card-display">
                      {{ validateSecurityCode('auto') }}
                    </div>
                    <div class="jp-card-shiny"></div>
                  </div>
                </div>
              </div>
            </div>
              <br />
            </div>
            <div class="row">
              <div class="pl-3">
                <input
                  class="form-control"
                  type="text"
                  id="txtCardNumbermob"
                  [maxlength]="maxLength"
                  placeholder="Credit Card Number"
                  (change)="validateCreditCardNumber()"
                  (keyup)="onChangeTxtCardNumber($event,true)"
                  [(ngModel)]="formattedCardNumber"
                  style="width: 220px !important; height: 38px !important"
                />
              </div>
              <div class="pl-2 mt-1">
                <img
                  style="width: 130px; height: auto !important"
                  src="/assets/images/cc-cards-images1.png"
                />
              </div>

              <div
                *ngIf="validCard"
                class="col-sm-6"
                style="font-size: 16px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  That card number did not work. Try again using Visa,
                  MasterCard, Discover or American Express
                </div>
              </div>
              <div
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes('DepositCreditCard Number')
                "
                class="col-sm-6"
                style="font-size: 16px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  That card number did not work. Please try re-entering it
                </div>
              </div>
            </div>
            <div class="row d-flex">
              <div class="px-0 mt-2">
                <div class="pl-3 mt-2">
                  <label class="mb-0 font-weight-semibold-calibre"
                    >Expiration Date*</label
                  >
                </div>
                <div class="row d-flex px-3">
                  <div class="mm-yy pl-3 pr-0">
                    <ng-select
                    [items]="monthList"
                    bindLabel="Text"
                    bindValue="Value"
                    placeholder="MM"
                    [searchable]="true" [clearable]="false"
                    id="cmonth"
                    name="month"
                    [(ngModel)]="month"
                    (change)="validateMonth()"
                    style="width: 110px"
                    >
                  </ng-select>
                  </div> 
                  <div class="mm-yy px-0">
                    <ng-select
                    [items]="yearsList"
                    bindLabel="Text"
                    bindValue="Value"
                    placeholder="YYYY"
                    [searchable]="true" [clearable]="false"
                    name="year"
                    id="cyear"
                    [(ngModel)]="year"
                    (change)="validateYear()"
                    style="width: 110px"
                     >
                    </ng-select>
                  </div>
                </div>
              </div>
              <div class="ml-4 mt-2 px-4">
                <div class="row mt-2">
                  <label class="mb-0 font-weight-semibold-calibre"
                    >Security Code*</label
                  >
                </div>
                <div class="row">
                  <input
                    class="form-control"
                    [(ngModel)]="secuiritycode"
                    (change)="validatecvv($event)"
                    (keyup)="
                      flipCardForSecurityCode(
                        $event.target.value,
                        'noauto'
                      )
                    "
                    id="cccode"
                    type="text"
                    style="width: 62px; height: 40px"
                    name="secuiritycode"
                    placeholder="CVV"
                    maxlength="4"
                    size="4"
                    required="true"
                  
                  />
                </div>
              </div>

              <div
                class="ml-3"
                *ngIf="blankmontherr"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Please provide the Expiration Month (MM)
                </div>
              </div>
              <div
                class="ml-3"
                *ngIf="blankyearerr"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Please provide the Expiration Year (YYYY)
                </div>
              </div>

              <div
                class="ml-3"
                *ngIf="showmontherr"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Date occurs in the past. Enter a future date
                </div>
              </div>
              <div
                *ngIf="
                  postResponseMessage &&
                  (postResponseMessage.includes('DepositCreditCardYear') ||
                    postResponseMessage.includes('DepositCreditCardMonth'))
                "
                class="ml-3"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Date occurs in the past. Enter a future date
                </div>
              </div>

              <div
                class="ml-3"
                *ngIf="cvvValid"
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Security code is invalid. Please verify and try again.
                </div>
              </div>
              <div
                class="ml-3"
                *ngIf="
                  postResponseMessage &&
                  postResponseMessage.includes('DepositCreditCard CVV/CID')
                "
                style="font-size: 14px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Security code is invalid. Please verify and try again.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-2">
                <label class="mb-0 font-weight-semibold-calibre mt-1"
                  >Name as it appears on card*</label
                >
              </div>
              <div class="col-sm-9">
                <input
                  class="form-control"
                  type="text"
                  IsAlphaNumeric
                  [(ngModel)]="cardName"
                  id="carddname"
                  name="cardname"
                  (change)="validateccName($event)"
                  placeholder="First and last name"
                  required="true"
                  (keyup)="flipCardFront('noauto')"
                />
              </div>
              <div
                class="ml-3"
                *ngIf="checkCardName"
                style="font-size: 16px !important; color: #ed1976 !important"
              >
                <div class="alertMsg">
                  Please provide your First and Last Name
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mt-2">
                <label class="mb-0 font-weight-semibold-calibre mt-1"
                  >Billing Address*</label
                >
              </div>
              <br />
              <div class="col-sm-12 px-0">
                <div class="col-sm-12 col-12 mb-2">
                  <input
                    type="text"
                    id="street_address"
                    [(ngModel)]="street_address"
                    class="form-control"
                    (ngModelChange)="validate()"
                    placeholder="Street Address"
                  />
                  <div
                    class="col-md-12 px-0 mb-1 alertMsg"
                    *ngIf="
                      postResponseMessage &&
                      postResponseMessage.includes(
                        'BillingAddress has reached its character limit'
                      )
                    "
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    Please enter a valid Billing Address
                  </div>
                  <div
                    class="col-md-12 px-0 mb-1 alertMsg"
                    *ngIf="street_addressisNull === true"
                    style="
                      font-size: 14px !important;
                      color: #ed1976 !important;
                    "
                  >
                    Billing Address is required and cannot be left blank
                  </div>
                </div>

                <div class="col-sm-3 col-4 mb-2">
                  <input
                    type="text"
                    id="apt"
                    [(ngModel)]="apt"
                    class="form-control"
                    (ngModelChange)="validate()"
                    placeholder="Apt"
                  />
                </div>
              </div>
              <div class="row col-sm-9 col-12 mb-2 pr-0">
                <div class="col-sm-4 col-6 pr-0">
                  <input
                    type="text"
                    [(ngModel)]="city"
                    (ngModelChange)="validate()"
                    class="form-control"
                    placeholder="City"
                  />
                </div>
                <div class="col-sm-3 col-3 pr-0 select-font16">
                  <ng-select
                    [items]="statesArr"
                    placeholder="Select"
                    [searchable]="true"
                    [clearable]="false"
                    name="selectedstate"
                    [(ngModel)]="state"
                    (change)="getState(state)"
                    #selectedstate="ngModel"
                  >
                  </ng-select>
                </div>
                <div class="col-sm-5 col-3 pr-0">
                  <input
                    type="tel"
                    numbersOnly
                    [(ngModel)]="zipcode"
                    (ngModelChange)="validate()"
                    class="form-control"
                    maxlength="5"
                    placeholder="Zip"
                  />
                </div>

                <div
                  class="ml-3"
                  *ngIf="cityisNull === true"
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">
                    City is required and cannot be left blank
                  </div>
                </div>
                <div
                  class="ml-3"
                  *ngIf="
                    postResponseMessage &&
                    postResponseMessage.includes('BillingCity')
                  "
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">Please enter a valid City</div>
                </div>
                <div
                  class="ml-3"
                  *ngIf="
                    zipInvalidLength === true ||
                    (postResponseMessage &&
                      postResponseMessage.includes('Zipcode'))
                  "
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">Please enter a 5-digit Zip Code</div>
                </div>
                <div
                  class="ml-3"
                  *ngIf="zipcodeisNull === true"
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">
                    Zipcode is required and cannot be left blank
                  </div>
                </div>

                <div
                  class="ml-3"
                  *ngIf="
                    postResponseMessage &&
                    postResponseMessage.includes(
                      'Unable to process your payment'
                    )
                  "
                  style="font-size: 14px !important; color: #ed1976 !important"
                >
                  <div class="alertMsg">
                    We are unable to process your payment. Please verify your
                    deposit details and try again.
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-sm-9 pl-0">
                <div
                  class="custom-control custom-checkbox chkbox ml-2 my-0 mb-0"
                  style="
                    margin-bottom: 0px !important;
                    border: none;
                    box-shadow: none !important;
                  "
                >
                  <input
                    type="checkbox"
                    id="accept"
                    class="custom-control-input"
                    [(ngModel)]="accpetterms"
                  />
                  <label
                    style="
                      cursor: pointer !important;
                      line-height: 100%;
                      font-size: 15px !important;
                      font-weight: normal;
                      color: black !important;
                    "
                    class="custom-control-label mt-1"
                    for="accept"
                    >I authorize BKV Energy to charge me the above mentioned
                    amount of {{ depositamount }} with the payment account
                    information provided. I understand that this is required to
                    complete the setup of establishing service with BKV
                    Energy.</label
                  >
                </div>
              </div>
            </div>
          </div>

         
          <div
            class="col-sm-9 col-9 pl-0 pr-4"
            *ngIf="Applyforadepositwaiver && !Paythe$175deposit"
          >
            <div class="row mt-2">
              <div class="col-sm-9 mx-2" id="order">
                <label
                  for="font-weight-semibold-calibre"
                  style="
                    font-size: 15px !important;
                    font-family: 'Calibre-SemiBold' !important;
                  "
                  >Choose from the following deposit waiver reasons</label
                >

                <ng-select
                  name="waiverreason"
                  [items]="waiverReasons"
                  placeholder="Select one"
                  [searchable]="true"
                  [clearable]="false"
                  (change)="checkreasonExists($event)"
                  [(ngModel)]="waiverreason"
                ></ng-select>
              </div>
              <div class="col-sm-2 col-2 pl-0"></div>

              <div *ngIf="IsReasonDes"  class="col-sm-10 col-10 pl-0 pr-4">
              <div   class="col-sm-8 offset-sm-2">
                <span class="ssnTxt d-inline-block mt-3 mb-3" [innerHTML]="ReasonDes"></span>
              </div>
              </div>


              <!-- <div class="col-sm-10 col-10 pl-0 pr-4">
                <div *ngIf="victimreason" class="col-sm-8 offset-sm-2">
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >If you are a victim of family violence, as defined in the
                    Texas Family Code §71.004, by a family violence center as
                    defined in Texas Human Resource Code §51.002, by treating
                    medical personnel, by law enforcement personnel, by the
                    Office of the Texas District Attorney or County Attorney, by
                    the Office of the Attorney General, or by a grantee of the
                    Texas Equal Access to Justice Foundation; you may be
                    eligible to have your deposit waived.
                  </span>
                  <span class="ssnTxt d-inline-block mb-3"
                    >You will need to provide your certified Letter for Family
                    Violence from the Texas Council on Family Violence which can
                    be downloaded here:<br />
                    <a
                      href="https://tcfv.org/survivor-resources"
                      target="_blank"
                      style="color: #0055ff"
                    >
                      https://tcfv.org/survivor-resources
                    </a>
                    found under "Utility Waivers."
                  </span>
                </div>

                <div *ngIf="seniorcitizen" class="col-sm-8 offset-sm-2">
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >Please provide proof that the Account Holder is 65 years of
                    age or older, and a copy of the most recent electric
                    invoice, to be eligible to have your deposit waived.
                  </span>
                </div>

                <div *ngIf="paymenthistory" class="col-sm-8 offset-sm-2">
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >Please provide a Letter of Credit from your current Retail
                    Electric Provider, or show 12 consecutive months of billing
                    and payment history with no more than 2 late payments, to be
                    eligible to have your deposit waived.
                  </span>
                </div>

                <div *ngIf="activehospitalemp" class="col-sm-8 offset-sm-2">
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >Active hospital employees are eligible to have their
                    deposit waived. Please submit a copy of a valid,
                    non-expired, hospital-issued employee picture ID.
                  </span>
                </div>

                <div *ngIf="activemilateryduty" class="col-md-12">
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >Active military personnel are eligible to have their
                    deposit waived. Please submit a copy of a valid,
                    non-expired, military-issued ID.
                  </span>
                </div>

                <div *ngIf="activemedicalindigent" class="col-md-12">
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >Please provide documentation showing that (1) the household
                    income is at or below 150% of the poverty guidelines. This
                    can be obtained from a governmental entity or a government
                    funded energy assistance program. Participating agencies can
                    be found here: <br />

                    <a
                      href="https://www.tdhca.state.tx.us/community-affairs/ceap"
                      target="_blank"
                      >https://www.tdhca.state.tx.us/community-affairs/ceap</a
                    ><br /><br />

                    And, (2) the customer or applicant, or the spouse of the
                    customer or applicant must have been certified by that
                    person’s physician as being unable to perform three or more
                    activities of daily living as defined in 22 TAC §224.4, or
                    the customer’s or applicant’s monthly out-of-pocket medical
                    expenses must exceed 20% of the household’s gross income.
                    <br /><br />

                    For purposes of this subsection, the term “physician” shall
                    mean any medical doctor, doctor of osteopathy, nurse
                    practitioner, registered nurse, state-licensed social
                    workers, state-licensed physical and occupational
                    therapists, and an employee of an agency certified to
                    provide home health services pursuant to 42 U.S.C. §1395 et
                    seq.
                  </span>
                </div>
              </div>

              <div class="col-sm-9 mx-2" id="order">
                <div
                  class="col-sm-12 px-0"
                  *ngIf="
                    victimreason ||
                    seniorcitizen ||
                    paymenthistory ||
                    activehospitalemp ||
                    activemilateryduty ||
                    activemedicalindigent
                  "
                >
                  <label
                    for="font-weight-semibold-calibre"
                    style="
                      line-height: 1;
                      font-size: 15px !important;
                      font-family: 'Calibre-SemiBold' !important;
                    "
                    >How would you like to provide your documentation</label
                  >

                  <ng-select
                    name="wayofcontact"
                    [items]="providewaystocontact"
                    placeholder="Select one"
                    [searchable]="false"
                    [clearable]="false"
                    (change)="providewaystocontactExists($event)"
                    [(ngModel)]="wayofcontact"
                  ></ng-select>
                </div>
              </div> -->


              <div class="col-sm-9 mx-2" id="order">
                <div
                  class="col-sm-12 px-0"
                  *ngIf="
                  IsReasonDes
                  "
                >
                  <label
                    for="font-weight-semibold-calibre"
                    style="
                      line-height: 1;
                      font-size: 15px !important;
                      font-family: 'Calibre-SemiBold' !important;
                    "
                    >How would you like to provide your documentation</label
                  >

                  <ng-select
                    name="wayofcontact"
                    [items]="providewaystocontact"
                    placeholder="Select one"
                    [searchable]="true"
                    [clearable]="false"
                    (change)="providewaystocontactExists($event)"
                    [(ngModel)]="wayofcontact"
                  ></ng-select>
                </div>
              </div> 

              <div class="col-sm-2 col-2 pl-0"></div>
              <div class="col-sm-10 col-10 pl-0 pr-4">
                <div
                  *ngIf="
                    emailorfax &&
                    waiverreason != 'Select one' &&
                    wayofcontact != 'Select one'
                  "
                  class="col-sm-12 offset-sm-2"
                >
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >To apply, please send your documents to BKV Energy via
                    email or fax in order to proceed with your enrollment
                    request.
                  </span>

                  <div
                    class="col-lg-12 px-0"
                    style="line-height: 1.3 !important"
                  >
                    <img
                      src="{{ selectedProduct.energy_provider_image }}"
                      class="text-center"
                      width="140"
                    />

                    <div class="row font15">
                      <div class="col-12 d-flex px-0">
                        <div class="col-3">Hours:</div>
                        <div class="col-9">
                          Monday to Friday 8:00 AM to 9:00 PM <br />
                          Saturday 8:00 AM to 5:00 PM
                        </div>
                      </div>
                      <div class="col-12 d-flex px-0">
                        <div class="col-3">Office:</div>
                        <div class="col-9">
                          <a
                            [href]="'tel:' + '1 855 BKV 4PWR(258-4797)'"
                            style="color: blue; cursor: pointer !important"
                          >
                          1 855 BKV 4PWR(258-4797)</a
                          >
                        </div>
                      </div>
                      <div class="col-12 d-flex px-0">
                        <div class="col-3">Email:</div>
                        <div class="col-9">
                          <span
                            style="
                              color: blue;
                              text-decoration: underline;
                              cursor: pointer;
                            "
                            (click)="mailMe('support@bkvenergy.com')"
                            >support@bkvenergy.com</span
                          >
                        </div>
                      </div>
                      <div class="col-12 d-flex px-0">
                        <div class="col-3">Fax:</div>
                        <div class="col-9">713-893-6012</div>
                      </div>
                    </div>
                  </div>

                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >You must email or fax your documentation to BKV Energy
                    within two (2) business days of the submitted enrollment
                    request. If you do not send your documentation within two
                    (2) business days, then your service request will be
                    cancelled and will be required to restart the enrollment
                    request process all over again.</span
                  >
                </div>
                <div
                  *ngIf="
                    isuploadfile &&
                    waiverreason != 'Select one' &&
                    wayofcontact != 'Select one'
                  "
                >
                  <span class="ssnTxt d-inline-block mt-3 mb-3"
                    >To apply, please upload your document(s).
                  </span>
                </div>
              </div>
              <div
                *ngIf="
                  isuploadfile &&
                  waiverreason != 'Select one' &&
                  wayofcontact != 'Select one'
                "
                class="col-md-12"
              >
                <div class="row col-sm-12 mb-2 ml-0 mr-0 p-0 borfderbtm">
                  <div
                    class="col-sm-12 text-center font16 semi-bold oneSpaces mb-2"
                  >
                    <label
                      class="upload-button text-center handsymbol boxbackgrdclr"
                      [ngClass]="{
                        'another-file-over': hasAnotherDropZoneOver
                      }"
                      style="cursor: pointer !important"
                    >
                      <div id="drop-area" (click)="fileOverAnother2($event)">
                        <span style="line-height: 100%">
                          <p
                            class="font16 semi-bold oneSpaces mt-3 my-0 fileUploadbottom fileUploadbottomHgt"
                          >
                            TAP TO UPLOAD DOCS OR TAKE A PICTURE
                          </p>
                          <p
                            class="font13 mb-0 oneSpaces regularfontFamily fileUploadbottom fileUploadbottomHgt"
                          >
                            Max File Size: 10MB
                          </p>
                          <p
                            class="font13 mb-2 oneSpaces regularfontFamily pb-2 fileUploadbottom fileUploadbottomHgt"
                          >
                            Acceptable File Types: JPG, PNG, PDF
                          </p>
                        </span>
                      </div>
                      <input
                        type="file"
                        (change)="onTempImageSelected($event)"
                        accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp"
                        multiple
                        name = 'photo' 
                      />
                    </label>
                    <ul class="upldfile">
                      <li *ngFor="let fileobj of listofFiles">
                        <div
                          class="handsymbol uploded"
                          *ngIf="listofFiles.length > 0"
                        >
                          <i class="fa fa-file mr-2"></i>
                          <span
                            >{{ fileobj.File.name }}
                            <small
                              class="text-muted clearfix float-left w-100"
                              >{{ fileobj.File.unitSize }}</small
                            >
                          </span>
                          <font class="upldclose" (click)="removeFile(fileobj)"
                            >x</font
                          >
                        </div>
                      </li>
                      <li
                        class="text-left alertMsg"
                        style="font-size: 12px !important"
                        *ngIf="listofFiles.length > 3"
                      >
                        Maximum of three (3) deposit documents allowed for
                        upload
                      </li>
                      <li
                        class="text-left alertMsg"
                        style="font-size: 12px !important"
                        *ngIf="invalidFileMsg"
                      >
                        Only JPEG, PNG and PDF files are acceptable file types
                      </li>
                      <li
                        class="text-left alertMsg"
                        style="font-size: 12px !important"
                        *ngIf="invalidFileSizeMsg"
                      >
                        This file is too big to upload. Max file size: 10 MB
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center">
              <button class="btn sectbtn mt-5" style="width:auto !important; padding-left:25px; font-size:18px; padding-right:25px;" [ngClass]="{'sectbtn': user_bot,'disabledButton':!user_bot}" (click) = "SendApiDetsils()" [disabled]="isDisable" >Submit Waiver</button>
            </div> -->

          <div
            class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center"
            *ngIf="Applyforadepositwaiver && !Paythe$175deposit"
          >
            <button
              class="btn sectbtn my-2"
              style="
                width: auto !important;
                padding-left: 25px;
                font-size: 18px !important;
                padding-right: 25px;
              "
              [ngClass]="{ sectbtn: user_bot, disabledButton: !user_bot }"
              (click)="SendApiDetsils()"
              [disabled]="isDisable"
            >
              Submit Waiver
            </button>
          </div>

          <div
            class="col-lg-7 col-md-12 col-sm-12 p-0 m-auto text-center"
            *ngIf="!Applyforadepositwaiver && Paythe$175deposit"
          >
            <button
              class="btn sectbtn my-2"
              style="
                width: auto !important;
                padding-left: 25px;
                font-size: 18px !important;
                padding-right: 25px;
              "
              [ngClass]="{ sectbtn: user_bot, disabledButton: !user_bot }"
              (click)="SendApiDetsils()"
              [disabled]="isDisable"
            >
              <i class="fa fa-lock mr-1" aria-hidden="true"></i>Pay Deposit Now
            </button>
          </div>

          <!-- <div class="m-auto col-md-10 blockbg boxclr text-center mt-3 py-4 px-3" *ngIf="postResponseMessage" style="vertical-align: middle; line-height: 1;">
              <p class="text-center tipmes mb-0"></p>
            </div> -->

          <div
            class="m-auto col-sm-12 blockbg boxclr text-center mt-3 py-4"
            *ngIf="postResponseMessage"
            style="
              vertical-align: middle;
              line-height: 1;
              width: 90% !important;
            "
          >
            <p class="text-center tipmes mb-0">{{ postResponseMessage }}</p>
          </div>
        </div>

        <!-- <div class="col-sm-9 col-12 mt-4">
              <p class="semi-bold ssndeptxt mb-1 text-center">Deposit Required</p>
              <p class="ssnTxt">In order to complete signing up for this plan, you
                are kindly being asked to post a deposit. To find out
                the deposit amount and for further details, please
                contact:
              </p>
              <div class="ssnenergyTxt text-center">
                <p class="fntbold mb-0 mt-2">{{providerContact != undefined && providerContact.provider_name ? providerContact.provider_name :""}}</p>
                <p class="mb-1">{{providerContact != undefined && providerContact.working_hours?providerContact.working_hours:""}}</p>
                <p class="fntbold clrblue">{{providerContact != undefined && providerContact.customerDeposit_enquiry?providerContact.customerDeposit_enquiry:""}}</p>
              </div>
              <p class="ssnTxt">
                Please be sure to mention Honest Gorilla and {{selectedProduct.product_key}}
                when you speak with a {{providerContact != undefined && providerContact.provider_name?providerContact.provider_name:""}} representative.
              </p>
            </div> -->

        <!-- <div  class="col-sm-9 col-12 ml-auto px-0" id ="addf_id">
                <div style="width:100% !important; text-align: right;">
                    <div  class="mb-3 ash_box text-right" [@flyOutans]="'in'" *ngIf="isChecked && ansinSSncheck1">
                       
                       <h1 class="inline-block ansMob text-right" *ngIf="isChecked">{{ansinSSncheck1}}</h1>
                    </div>
                </div>
            </div> -->

        <div id="thankAns">
          <div
            class="d-flex h-100 row pr-0 mt-3"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'Thank you, goodbye' &&
              timeTrue == true
            "
          >
            <div
              class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
            >
              <img
                style="width: 100% !important"
                src="assets/images/signimg.jpg"
              />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div
                class="arrow_box mr-3"
                [@flyOutans]="'in'"
                *ngIf="isChecked && ansinSSncheck1 == 'Thank you, goodbye'"
              >
                <h1 class="questionMob">
                  Got it, but before you leave, if you have any questions why
                  your enrollment request did not go through and want to speak
                  to someone about it, you may contact
                  <span class="font-weight-bold p-1">{{
                    selectedProduct.energy_provider
                  }}</span>
                  <span class="mb-1"
                    >{{
                      providerContact != undefined &&
                      providerContact.working_hours
                        ? providerContact.working_hours
                        : ''
                    }} </span
                  ><br />
                  <span class="fntbold clrblue"
                    ><a
                      [href]="'tel:' + providerContact.customerDeposit_enquiry"
                      style="color: #1f0bcc !important"
                      >{{
                        providerContact != undefined &&
                        providerContact.customerDeposit_enquiry
                          ? providerContact.customerDeposit_enquiry
                          : ''
                      }}.</a
                    ></span
                  >
                  <span>
                    Be sure to mention Honest Gorilla, when you speak with a
                    {{ providerContact.provider_name }} representative.</span
                  >
                </h1>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-12 px-0"
            id="thankAns1"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'Thank you, goodbye' &&
              timeTrue == true
            "
          >
            <label
              class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow"
              for="thankyou"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="thankyou"
                value="Thank you"
                name="thankyou"
                [(ngModel)]="ssndepostList.value8"
                (click)="onChangeRole($event)"
              />
              <label class="custom-control-label font20" for="thankyou"
                >Thank you</label
              >
            </label>
          </div>
        </div>

        <div id="speaksomeone">
          <div
            class="d-flex h-100 row pr-0 mt-3"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'I would like to speak with someone' &&
              timeTrue == true
            "
          >
            <div
              class="justify-content-center align-self-center col-sm-3 col-3 pl-0"
            >
              <img
                style="width: 100% !important"
                src="assets/images/signimg.jpg"
              />
            </div>
            <div class="col-sm-9 col-9 px-0 my-auto">
              <div
                class="arrow_box mr-3"
                [@flyOutans]="'in'"
                *ngIf="
                  isChecked &&
                  ansinSSncheck1 == 'I would like to speak with someone'
                "
              >
                <h1 class="questionMob">
                  To learn more details why your enrollment request did not go
                  through, please contact
                  <span class="font-weight-bold p-1">{{
                    selectedProduct.energy_provider
                  }}</span>
                  <span class="mb-1"
                    >{{
                      providerContact != undefined &&
                      providerContact.working_hours
                        ? providerContact.working_hours
                        : ''
                    }}
                  </span>
                  <span class="fntbold clrblue"
                    ><a
                      [href]="'tel:' + providerContact.customerDeposit_enquiry"
                      style="
                        cursor: pointer !important;
                        color: #1f0bcc !important;
                      "
                      >{{
                        providerContact != undefined &&
                        providerContact.customerDeposit_enquiry
                          ? providerContact.customerDeposit_enquiry
                          : ''
                      }}.</a
                    ></span
                  ><br />
                  <span>
                    Be sure to mention Honest Gorilla, when you speak with a
                    {{ providerContact.provider_name }} representative.</span
                  >
                </h1>
              </div>
            </div>
          </div>
          <div
            class="col-sm-12 col-12 px-0"
            id="thankAns1"
            *ngIf="
              isChecked &&
              ansinSSncheck1 == 'I would like to speak with someone' &&
              timeTrue == true
            "
          >
            <label
              class="custom-control custom-checkbox chkbox mb-2 pr-0 box-shadow"
              for="thankyou"
            >
              <input
                type="checkbox"
                class="custom-control-input mgntp10"
                id="thankyou"
                value="Thank you"
                name="thankyou"
                [(ngModel)]="ssndepostList.value8"
                (click)="onChangeRole($event)"
              />
              <label class="custom-control-label font20" for="thankyou"
                >Thank you</label
              >
            </label>
          </div>
        </div>

        <div class="col-sm-9 col-9 ml-auto mt-4 px-0">
          <div class="col-12" style="width: 100% !important; text-align: right">
            <div
              id="secondAns_id"
              class="mb-3 ash_box text-right"
              [@flyOutans]="'in'"
              *ngIf="ansinSSncheck2 == 'Goodbye'"
            >
              <h1 class="ansMob text-right">{{ ansinSSncheck2 }}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<p class="m-0 text-muted tapmsg" style="color: #0055ff !important">
  <a
    href="javascript:void(0)"
    id="openModalButtonForAction"
    (click)="openModal(template)"
  >
  </a>
</p>

<ng-template #template>
  <div>
    <div class="modal-dialog" role="document">
      <div class="modal-content zind1 boxRadius">
        <div class="modal-body">
          <button
            type="button"
            class="close videoclose"
            id="closeModelAlign"
            data-dismiss="modal"
            aria-label="Close"
            (click)="hideModal()"
          >
            <div class="float-right mr-2">
              <img src="assets/images/editchart-close.svg" width="20" />
            </div>
          </button>

          <div class="service-modal px-sm-4">
            <div class="modal-border">
              <h1
                class="text-left conthead font-weight-bold-calibre mt-4 pt-2 mb-2"
                style="font-size: 20px !important"
              >
                Help is on the way
              </h1>
              <span style="clear: left"></span>
            </div>
            <div class="bdy-section pt-0">
              <div>
                <p class="mt-2">
                  You can contact
                  <span class="font-weight-bold">{{
                    selectedProduct.energy_provider
                  }}</span>
                  <span class="mb-1 px-1">{{
                    providerContact != undefined &&
                    providerContact.working_hours
                      ? providerContact.working_hours
                      : ''
                  }}</span>
                  <br /><span class="fntbold clrblue"
                    ><a
                      [href]="'tel:' + providerContact.customerDeposit_enquiry"
                      style="color: #1f0bcc !important"
                      >{{
                        providerContact != undefined &&
                        providerContact.customerDeposit_enquiry
                          ? providerContact.customerDeposit_enquiry
                          : ''
                      }}</a
                    ></span
                  >
                </p>

                <p class="mb-4">
                  If you are receiving this message outside of business hours,
                  then feel free to leave a Voicemail at the number provided
                  above and someone will respond to you at their earliest
                  convenience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal !-->
